<template>
  <Card class="page-disease">
    <div style="display: flex; margin-bottom: 15px">
      <div style="flex: 1; display: flex">
        <el-input
          v-model="keywords"
          placeholder="请输入关键字搜索"
          style="max-width: 350px"
          @keyup.enter.native="getQueryList"
        />

        <el-select
          v-model="disease_name"
          @change="selectDisease"
          filterable
          :label-in-value="true"
          placeholder="请选择要管理的病种"
          style="margin:0 10px"
        >
          <el-option v-for="d in disease" :key="d.id" :value="d.name">
            {{
            d.name
            }}
          </el-option>
        </el-select>
        <el-button type="primary" round style="margin-left: 30px" @click="getQueryList">搜索</el-button>
      </div>
    </div>
    <Table :columns="columns" :data="dataSource" :loading="loading">
      <template slot-scope="{ row }" slot="action">
        <el-button type="text" style="margin-right: 10px" @click="edit(row)">设置排序</el-button>
      </template>
    </Table>
    <div style="margin-top: 16px; text-align: right">
      <Page
        :total="total"
        :current="page"
        :page-size="size"
        :page-size-opts="sizes"
        :show-total="true"
        :show-elevator="true"
        :show-sizer="true"
        @on-change="onCurrentChange"
        @on-page-size-change="onSizeChange"
      />
    </div>
    <Modal v-model="show" :mask-closable="false" width="550" @on-cancel="cancel">
      <div slot="header" style="text-align: center">
        <span>{{cur.id ? '设置排序' : '新增排序'}}</span>
      </div>
      <Form
        ref="form"
        :model="cur"
        :label-width="150"
        :rules="rule"
        label-position="right"
        style="margin-left: -40px;margin-right: 40px"
      >
        <FormItem label="排序号序" prop="sort_no">
          <Input v-model.trim="cur.sort_no" :disabled="read" placeholder="请填写排序号序"></Input>
        </FormItem>
      </Form>
      <div slot="footer" style="text-align: center">
        <el-button v-if="!read" type="info" round @click="cancel">取消</el-button>
        <el-button v-if="!read" type="primary" round :loading="modalLoading" @click="save">保存</el-button>
      </div>
    </Modal>
  </Card>
</template>
<script>
import { getDiagSortApi, updateDiagSortApi } from '../../api/diagnosisSort'
import { getDiseaseListApi } from '../../api/manage'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      keywords: '',
      disease_id: '',
      disease_name: '',
      disease: [],
      columns: [
        {
          title: 'ID',
          align: 'center',
          key: 'id',
        },
        {
          title: '诊断名称',
          align: 'center',
          key: 'diagnosis_name',
        },
        {
          title: '诊断编码',
          align: 'center',
          key: 'icd_diagnosis_code',
        },
        {
          title: '诊断类型',
          align: 'center',
          key: 'diagnosis_type',
        },
        {
          title: '排序码',
          align: 'center',
          key: 'sort_no',
          render: (h, params) => {
            return h('div', params.row.sort_no || '--')
          },
        },
        {
          title: '五笔码',
          align: 'center',
          key: 'wb_code',
        },
        {
          title: '拼音码',
          align: 'center',
          key: 'pin_code',
        },
        {
          title: '简拼码',
          align: 'center',
          key: 'spell_code',
        },
        {
          title: '操作',
          align: 'center',
          slot: 'action',
        },
      ],
      dataSource: [],
      cur: {},
      rule: {
        sort_no: [
          {
            required: true,
            message: '请填写排序号序',
            // trigger: 'blur',
          },
          {
            required: true,
            message: '请填写排序号序',
            // trigger: 'change',
          },
          // {
          //   pattern: /^[\u4e00-\u9fa5_()（）a-zA-Z0-9]+$/,
          //   message: '请输入由中英文、数字、括号以及下划线组成的诊断名称',
          //   trigger: 'blur',
          // },
          // {
          //   pattern: /^[\u4e00-\u9fa5_()（）a-zA-Z0-9]+$/,
          //   message: '请输入由中英文、数字、括号以及下划线组成的诊断名称',
          //   trigger: 'change',
          // },
        ],
      },
      read: false,
      loading: false,
      show: false,
      modalLoading: false,
      total: 0,
      page: 1,
      size: 10,
      sizes: [10, 20, 30, 40, 50],
    }
  },
  computed: {
    ...mapGetters(['shift']),
  },
  created() {
    this.getDiseaseList()
  },
  methods: {
    getDiseaseList() {
      getDiseaseListApi({ page: 1, size: 999 }).then((res) => {
        if (res.code === 0) {
          this.disease = res.data
          this.disease_name = res.data[0].name
          this.disease_id = res.data[0].id
          this.getList()
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    selectDisease(j) {
      console.log(j)
      this.disease.forEach((v) => {
        if (v.name == j) {
          this.disease_id = v.id
          this.getList()
        }
      })
    },
    onCurrentChange(current) {
      this.page = current
      this.getList()
    },
    onSizeChange(size) {
      this.size = size
      this.getList()
    },
    getQueryList() {
      this.page = 1
      this.getList()
    },
    getList() {
      this.loading = true
      const { page, size, keywords, disease_id } = this
      getDiagSortApi({
        page,
        size,
        keywords,
        disease_id,
        institution_id: this.shift.institution_id,
      })
        .then((res) => {
          this.loading = false
          if (res.code === 0) {
            this.dataSource = res.data
            this.total = res['x-total-count'] || res.data.length
            if (this.total && !this.dataSource.length && this.page > 1) {
              this.page = this.page - 1
              this.getList()
            }
          } else {
            this.$Message.error(res.message)
          }
        })
        .catch(() => (this.loading = false))
    },
    showModal() {
      this.show = true
    },

    edit(row) {
      this.cur = JSON.parse(JSON.stringify(row))
      this.cur.disease_id = this.disease_id
      this.showModal()
    },

    cancel() {
      this.$refs.form.resetFields()
      this.show = false
      this.modalLoading = false
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.modalLoading = true

          if (this.cur.id) {
            updateDiagSortApi(this.cur).then((res) => {
              this.modalLoading = false
              if (res.code === 0) {
                this.cancel()
                this.getList()
              } else {
                this.$Message.error(res.message)
              }
            })
          }
          // else {
          //   addDiagApi(this.cur).then((res) => {
          //     this.modalLoading = false
          //     if (res.code === 0) {
          //       this.cancel()
          //       this.getList()
          //     } else {
          //       this.$Message.error(res.message)
          //     }
          //   })
          // }
        }
      })
    },
  },
}
</script>
<style lang="less">
.page-disease {
  .error {
    color: #f56c6c;
    &:focus,
    &:hover {
      color: #f78989;
    }
  }
}
</style>
